import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=0bef1cf5&scoped=true&"
import script from "./LinkIcon.vue?vue&type=script&lang=js&"
export * from "./LinkIcon.vue?vue&type=script&lang=js&"
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=0bef1cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef1cf5",
  null
  
)

export default component.exports